"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isContinuous = exports.getScales = exports.getQuantizeScales = exports.getThresholdScales = exports.getQuantileScales = exports.getContinuousScales = exports.getCategoryScales = exports.getColors = exports.getColorInterpolator = exports.getChunks = exports.getCategoryChunks = exports.getPositionScale = exports.getColorScale = exports.getExtent = exports.getGroups = void 0;

var _d3Interpolate = require("d3-interpolate");

var chromatic = _interopRequireWildcard(require("d3-scale-chromatic"));

var _d3Array = require("d3-array");

var _d3Color = require("d3-color");

var _d3Scale = require("d3-scale");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Returns an array of group values given a selector
 * @param {Array<object>} data
 * @param {function} selector
 * @returns
 */
var getGroups = function getGroups(data, selector) {
  return Array.from((0, _d3Array.group)(data, selector).keys());
};
/**
 * Returns the extent of the provided data, or uses min / max values if provided
 */


exports.getGroups = getGroups;

var getExtent = function getExtent(data, _ref) {
  var min = _ref.min,
      max = _ref.max,
      _ref$accessor = _ref.accessor,
      accessor = _ref$accessor === void 0 ? function (d) {
    return d;
  } : _ref$accessor;
  // return min / max as extent if they are set
  if (Number.isFinite(min) && Number.isFinite(max)) return [min, max]; // no data, return min / max or default values

  if (!data || data.length === 0) return [min || 0, max || 1];
  var dataExtent = (0, _d3Array.extent)(data, accessor);
  return [min || dataExtent[0], max || dataExtent[1]];
};
/**
 * Creates a scale for mapping a domain to colors
 * @param {string} type
 * @param {Array} domain
 * @param {Array} colors
 * @returns
 */


exports.getExtent = getExtent;

var getColorScale = function getColorScale(type, domain, colors) {
  if (!Array.isArray(domain)) throw new Error("must provide domain for color scale");

  switch (type) {
    case "quantile":
      return (0, _d3Scale.scaleQuantile)().domain(domain).range(colors);

    case "quantize":
      return (0, _d3Scale.scaleQuantize)().domain(domain).range(colors);

    case "threshold":
      return (0, _d3Scale.scaleThreshold)().domain(domain).range(colors);

    case "category":
      return (0, _d3Scale.scaleOrdinal)().domain(domain).range(colors);

    case "linear":
      return (0, _d3Scale.scaleLinear)().domain(domain).range(colors);

    case "sequential":
      var interpolator = getColorInterpolator(colors);
      return (0, _d3Scale.scaleSequential)(interpolator).domain(domain);

    default:
      throw new Error("invalid scale type for color scale");
  }
};
/**
 * Returns a scale for mapping domain to a position
 * @param {string} type
 * @param {Array} domain
 * @param {Array} range
 * @param {object} options
 * @returns
 */


exports.getColorScale = getColorScale;

var getPositionScale = function getPositionScale(type, domain, range) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (!Array.isArray(domain) || !Array.isArray(range)) throw new Error("must provide domain and range for position scale");
  var scale;

  switch (type) {
    case "category":
      scale = (0, _d3Scale.scaleBand)().domain(domain).range(range);
      break;

    case "quantile":
    case "threshold":
    case "linear":
      scale = (0, _d3Scale.scaleLinear)().domain((0, _d3Array.extent)(domain)).range(range).clamp(true);
      break;

    default:
      scale = (0, _d3Scale.scaleLinear)().domain(domain).range(range).clamp(true);
      break;
  }

  return options.nice ? scale.nice() : scale;
};
/**
 * Takes a position scale and a color scale and creates "chunks"
 * that correspond to rectangles for creating a category scale
 * @returns {Array<object>} [{value, x, width, color}]
 */


exports.getPositionScale = getPositionScale;

var getCategoryChunks = function getCategoryChunks(_ref2) {
  var positionScale = _ref2.positionScale,
      colorScale = _ref2.colorScale;
  return colorScale.domain().map(function (d) {
    return {
      value: d,
      x: positionScale(d),
      width: positionScale.bandwidth(),
      color: colorScale(d)
    };
  });
};
/**
 * Takes a position scale and a color scale and creates "chunks"
 * that correspond to rectangles for creating discrete color scales
 * @returns {Array<object>} [{value, x, width, color}]
 */


exports.getCategoryChunks = getCategoryChunks;

var getChunks = function getChunks(_ref3) {
  var positionScale = _ref3.positionScale,
      colorScale = _ref3.colorScale;
  var scaleCuts = colorScale.thresholds ? colorScale.thresholds() : colorScale.quantiles ? colorScale.quantiles() : colorScale.domain();
  var limits = [positionScale.domain()[0]].concat(_toConsumableArray(scaleCuts), [positionScale.domain()[1]]);
  var boxLimits = limits.slice(0, limits.length - 1).map(function (d, j) {
    return [limits[j], limits[j + 1]];
  });
  return boxLimits.map(function (l, k) {
    return {
      value: [l[0], l[1]],
      x: positionScale(l[0]),
      width: positionScale(l[1]) - positionScale(l[0]),
      color: colorScale.range()[k]
    };
  });
};
/**
 * Gets a color interpolator based on a d3-scale-chromatic color scale
 * string or an array of colors
 * @param {*} value
 * @returns {function}
 */


exports.getChunks = getChunks;

var getColorInterpolator = function getColorInterpolator(value) {
  var interpolate;
  if (Array.isArray(value)) interpolate = (0, _d3Interpolate.piecewise)(_d3Interpolate.interpolateRgb.gamma(2.2), value);
  if (typeof value === "string" && chromatic["interpolate".concat(value)]) interpolate = chromatic["interpolate".concat(value)];
  if (!interpolate) throw new Error("cannot create colors");
  return interpolate;
};
/**
 * Takes a d3-scale-chromatic color scale string or an array of colors
 * and maps it to an array where the length corresponds to `numColors`
 * @param {string|Array} value
 * @param {number} numColors
 * @returns {Array<string>} array containing hex formatted strings
 */


exports.getColorInterpolator = getColorInterpolator;

var getColors = function getColors(value, numColors) {
  var interpolate = getColorInterpolator(value);
  var colors = [];

  for (var i = 0; i < numColors; ++i) {
    colors.push((0, _d3Color.rgb)(interpolate(i / (numColors - 1))).formatHex());
  }

  return colors;
};
/**
 * Returns position, and color scales along with
 * chunks that represent segments on the scale
 */


exports.getColors = getColors;

var getCategoryScales = function getCategoryScales(data, colors) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options = _objectSpread({
    accessor: function accessor(d) {
      return d;
    }
  }, options);
  if ((!data || data.length === 0) && !options.categories) throw new Error("must provide data or categories option for category scale");
  var categories = options.categories || getGroups(data, options.accessor).sort(options.sorter);
  var scaleColors = getColors(colors, categories.length);
  var positionScale = getPositionScale("category", categories, [0, 1]);
  var colorScale = getColorScale("category", categories, scaleColors);
  return {
    position: positionScale,
    color: colorScale,
    chunks: getCategoryChunks({
      positionScale: positionScale,
      colorScale: colorScale
    })
  };
};
/**
 * Returns position, and color scales
 */


exports.getCategoryScales = getCategoryScales;

var getContinuousScales = function getContinuousScales(data, colors) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options = _objectSpread({
    nice: true,
    accessor: function accessor(d) {
      return d;
    }
  }, options);
  var domain = getExtent(data, options);
  var positionScale = getPositionScale("linear", domain, [0, 1], {
    nice: options.nice
  });
  var colorScale = getColorScale("sequential", domain, colors);
  return {
    position: positionScale,
    color: colorScale
  };
};
/**
 * Returns quantile, position, and color scales along with
 * chunks that represent segments on the scale
 */


exports.getContinuousScales = getContinuousScales;

var getQuantileScales = function getQuantileScales(data, colors) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!data || !data.length) throw new Error("no data provided for quantile scale"); // add defaults top options if they are not set

  options = _objectSpread({
    amount: 5,
    nice: true,
    accessor: function accessor(d) {
      return d;
    }
  }, options);
  var values = data.map(options.accessor);
  var scaleColors = getColors(colors, options.amount);
  var positionScale = getPositionScale("quantile", values, [0, 1], {
    nice: options.nice
  });
  var colorScale = getColorScale("quantile", values, scaleColors);
  var quantileScale = (0, _d3Scale.scaleQuantile)().domain(values).range(new Array(options.amount).fill(1).map(function (v, i) {
    return i;
  }));
  return {
    quantile: quantileScale,
    position: positionScale,
    color: colorScale,
    chunks: getChunks({
      positionScale: positionScale,
      colorScale: colorScale
    })
  };
};
/**
 * Returns threshold, position, and color scales along with
 * chunks that represent segments on the scale
 */


exports.getQuantileScales = getQuantileScales;

var getThresholdScales = function getThresholdScales(data, colors) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options = _objectSpread({
    nice: true,
    thresholds: [0, 1],
    accessor: function accessor(d) {
      return d;
    }
  }, options);
  var domain = getExtent(data, options);
  var scaleColors = getColors(colors, options.thresholds.length + 1);
  var colorScale = getColorScale("threshold", options.thresholds, scaleColors);
  var positionScale = getPositionScale("threshold", domain, [0, 1], {
    nice: options.nice
  });
  var thresholdScale = (0, _d3Scale.scaleThreshold)().domain(options.thresholds).range(new Array(options.thresholds.length + 1).fill(1).map(function (v, i) {
    return i;
  }));
  return {
    threshold: thresholdScale,
    position: positionScale,
    color: colorScale,
    chunks: getChunks({
      positionScale: positionScale,
      colorScale: colorScale
    })
  };
};
/**
 * Returns quantize, position, and color scales along with
 * chunks that represent segments on the scale
 */


exports.getThresholdScales = getThresholdScales;

var getQuantizeScales = function getQuantizeScales(data, colors) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // add defaults top options if they are not set
  options = _objectSpread({
    amount: 5,
    nice: true,
    accessor: function accessor(d) {
      return d;
    }
  }, options);
  var domain = getExtent(data, options);
  var scaleColors = getColors(colors, options.amount);
  var positionScale = getPositionScale("quantize", domain, [0, 1], {
    nice: options.nice
  });
  var colorScale = getColorScale("quantize", positionScale.domain(), scaleColors);
  var quantizeScale = (0, _d3Scale.scaleQuantize)().domain(positionScale.domain()).range(new Array(options.amount).fill(1).map(function (v, i) {
    return i;
  }));
  return {
    quantize: quantizeScale,
    position: positionScale,
    color: colorScale,
    chunks: getChunks({
      positionScale: positionScale,
      colorScale: colorScale
    })
  };
};
/**
 * Helper function to get scales for the provided scale type and options
 * @param {*} type type of scale (category, quantile, threshold, quantize, continuous)
 * @param {*} data the dataset for the scale
 * @param {*} colors array of colors for the scale
 * @param {*} options { min, max, accessor, amount, nice, thresholds }
 * @returns
 */


exports.getQuantizeScales = getQuantizeScales;

var getScales = function getScales(type, data, colors, options) {
  switch (type) {
    case "category":
      return getCategoryScales(data, colors, options);

    case "quantile":
      return getQuantileScales(data, colors, options);

    case "threshold":
      return getThresholdScales(data, colors, options);

    case "quantize":
      return getQuantizeScales(data, colors, options);

    case "continuous":
      return getContinuousScales(data, colors, options);

    default:
      throw new Error("unsupported scale type: ".concat(type));
  }
};

exports.getScales = getScales;

var isContinuous = function isContinuous(type) {
  return type === "continuous";
};

exports.isContinuous = isContinuous;